import JESalary from "./salary";
export default JESalary;
